// import Vue from 'vue'
// import App from './App.vue'
//
// import '@/dojia/wx.js';
//
// // global css
// import '@/style/main.less'
//
// Vue.config.productionTip = false
//
// new Vue({
//   render: h => h(App),
// }).$mount('#app')



import Vue from 'vue';
import App from './App';
// import { router } from '@/router';
import 'amfe-flexible';
import store from "@/store";
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from '@/services/axios'
import '@/assets/less/common.less'

Vue.use(Vant);
Vue.prototype.$http = axios;

new Vue({
  // router,
  store,
  el: '#app',
  render: h => h(App)
});

//
//
//<img class="ad-pic" src="https://dummyimage.com/345x96" alt="">
